<template>
  <div class="editorTool">
    <Step
      v-if="isShowStep"
      :step-index="stepIndex"
    />
    <Tips :content="content" />
    <Pedesta
      v-if="pedestalId"
      :template-show-data="TmpData"
      :pedestal-id="pedestalId"
      @getPedestaData="getPedestaData"
    />
  </div>
</template>

<script>
import {
  getPagesTemplateDetail,
  savePagesTemplate,
  getPagesTemplateList
} from '@/api/weappTmpApis/editorTool'
import Pedesta, { registerPedestal } from '@/view/weappTmp/index.vue'
import Step from './step'
import Tips from './tips'

import testData from '@/view/weappTmp/test/activeTest.json'
export default {
  components: {
    Pedesta,
    Step,
    Tips
  },
  data () {
    return {
      // 基座配置项
      pedestalId: '',
      TmpData: {},
      isShowStep: false,
      stepIndex: '2',
      content:
        '拖拽左侧组件至中间区域创建表单页内容，中间可拖动区域的表单区域可上下拖动表单项，调整表单项填写顺序。'
    }
  },
  created () {
    const query = this.$route.query
    console.log('this.query', query)
    if (query.activity_id && query.activity_id !== '0') {
      this.getTmpData(query.activity_id)
    } else {
      this.initEditorTool()
    }
    if (query.showStep && query.showStep === '1') {
      this.isShowStep = true
      this.content = '不配置模版，当前活动直接使用关联表单页'
    }
  },
  mounted () {},
  methods: {
    async getTmpData (activity_id) {
      // getPagesTemplateDetail
      // this.TmpData = testData
      const data = await getPagesTemplateDetail({
        activity_id: activity_id
      })
      if (data && data.activity_template) {
        this.TmpData = JSON.parse(data.activity_template)
        console.log(this.TmpData, 'this.TmpData')
      }
      this.initEditorTool()
    },
    // 初始化 模版装修器基座
    initEditorTool () {
      this.pedestalId = registerPedestal({
        type: 'activeTmps',
        title: '活动',
        name: 'activeWeappTmp'
      })
    },
    async getPedestaData (content) {
      console.log('保存活动：getPedestacontent', content)
      console.log(JSON.stringify(content))
      const query = this.$route.query
      let filter = {
        activity_id: query.activity_id,
        // distributor_id: this.relStore.id,
        template_name: (content.homeConfig && content.homeConfig.formPageConfig.title) || '页面名称',
        activity_template: JSON.stringify({
          content: { ...content }
        })
      }
      const data = await savePagesTemplate(filter)
      if (data) {
        this.$message({
          message: '保存成功',
          type: 'success',
          onClose: () => {
            this.$emit('saved', false)
            this.$router.push({
              path: '/drainage/formActivity'
            })
          }
        })
      }
      // this.$emit('savePedestaData', JSON.stringify(data))
    }
  }
}
</script>
<style lang="scss" scoped></style>
